<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <v-alert
              v-if="notificationStore.success"
              v-model="notificationStore.success"
              type="success"
              dismissible
              >{{ notificationStore.text }}</v-alert
            >
            <v-alert
              v-if="notificationStore.warning"
              v-model="notificationStore.warning"
              type="warning"
              dismissible
              >{{ notificationStore.text }}</v-alert
            >
            <v-alert
              v-if="notificationStore.error"
              v-model="notificationStore.error"
              type="error"
              dismissible
              >{{ notificationStore.text }}</v-alert
            >
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <!-- <v-footer height="auto" class="white pa-3 app--footer">
          </v-footer> -->
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        >
        </v-navigation-drawer>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import AppFab from "@/components/AppFab";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    notificationStore: {}
  }),
  mounted: function() {
    this.notificationStore = this.getNotificationStore();
  },
  computed: {},

  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    getNotificationStore() {
      return this.$store.state.notification;
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab
  top:50%!important;
  right:0;
  border-radius:0
.page-wrapper
  min-height:calc(100vh - 64px - 50px - 81px );
</style>
